import { z } from 'zod';
/** Print */
export const zPrintSize = z.object({
    name: z.string().optional(),
    width: z.number(),
    height: z.number(),
});
/** FlowStatus */
const FlowStatusValues = z.object({
    text: z.string(),
    tooltip: z.string().optional().default(''),
});
export const FlowStatus = z.object({
    values: z.array(FlowStatusValues),
    defaultSelection: z.array(z.number()),
});
/** Placeholder */
export const Placeholder = z.object({
    text: z.string(),
});
export const Perspective = z.string();
export const CartItemType = z.union([z.literal('similar'), z.literal('existing')]);
export var AppType;
(function (AppType) {
    AppType["Assortment"] = "Assortment";
    AppType["TDAnalysis"] = "TDAnalysis";
    AppType["Configurator"] = "Configurator";
    AppType["Allocation"] = "Allocation";
    AppType["FinancialPlanning"] = "FinancialPlanning";
})(AppType || (AppType = {}));
export const zPlanType = z.union([z.literal('assortment'), z.literal('allocation')]);
export var FooterType;
(function (FooterType) {
    FooterType["none"] = "none";
    FooterType["insights"] = "insights";
})(FooterType || (FooterType = {}));
